import _ from "lodash";

const Key = (props) => {
    let tried = false;
    let present = false;
    let correctPosition = false;
    let presentIndex = -1;

    _.forEach(props.attempts, (attempt, index) => {
        if (index === props.attempt) {
            return;
        }
        let triedIndex = attempt.indexOf(props.text);
        if (triedIndex !== -1) {
            tried = true;
        }
        if (tried) {
            presentIndex = props.word.indexOf(props.text);
            if (presentIndex !== -1) {
                present = true;
            }
        }
        if (present && props.word[presentIndex] === attempt[presentIndex]) {
            correctPosition = true;
            return false;
        }
        
    });

    return (
        correctPosition
        ? <button class="key key--correct" onClick={() => props.onClick(props.text)}>{props.text}</button>
        : present
        ? <button class="key key--present" onClick={() => props.onClick(props.text)}>{props.text}</button>
        : tried
        ? <button class="key key--tried" onClick={() => props.onClick(props.text)}>{props.text}</button>
        : <button class="key" onClick={() => props.onClick(props.text)}>{props.text}</button>
    );
}

export default Key;